import { useState } from 'react';
import { Link } from 'react-router-dom';
import useScrollAnimation from '../hooks/useScrollAnimation';
import Lightbox from '../components/Lightbox';

// Album showcase — curated mix
import wed02 from '../imagesForCategory/Wedding/Wed 02.jpg';
import wed05 from '../imagesForCategory/Wedding/Wed 05.jpg';
import wed10 from '../imagesForCategory/Wedding/Wed 10.jpg';
import en01 from '../imagesForCategory/Engagement/En 01.jpg';
import en05 from '../imagesForCategory/Engagement/En 05.jpg';
import en10 from '../imagesForCategory/Engagement/En 10.jpg';
import ha01 from '../imagesForCategory/Haldi/Ha 01.jpg';
import ha05 from '../imagesForCategory/Haldi/Ha 05.jpg';
import prew01 from '../imagesForCategory/Prewedding/Prew 01.jpg';
import prew05 from '../imagesForCategory/Prewedding/Prew 05.jpg';
import br01 from '../imagesForCategory/Bride & groom/Br 01.jpg';
import br05 from '../imagesForCategory/Bride & groom/Br 05.jpg';
import re01 from '../imagesForCategory/Reception/Re 01.jpg';
import re05 from '../imagesForCategory/Reception/Re 05.jpg';
import sa01 from '../imagesForCategory/Sangeet/Sa 01.jpg';
import me01 from '../imagesForCategory/Mehendi/Me 01.jpg';
import sti01 from '../imagesForCategory/Stills/Sti 01.jpg';
import sti02 from '../imagesForCategory/Stills/Sti 02.jpg';

const albumImages = [
  { src: wed02, label: 'Wedding' },
  { src: en01, label: 'Engagement' },
  { src: ha01, label: 'Haldi' },
  { src: prew01, label: 'Pre Wedding' },
  { src: br01, label: 'Bride & Groom' },
  { src: re01, label: 'Reception' },
  { src: sa01, label: 'Sangeet' },
  { src: me01, label: 'Mehendi' },
  { src: wed05, label: 'Wedding' },
  { src: en05, label: 'Engagement' },
  { src: ha05, label: 'Haldi' },
  { src: prew05, label: 'Pre Wedding' },
  { src: br05, label: 'Bride & Groom' },
  { src: re05, label: 'Reception' },
  { src: wed10, label: 'Wedding' },
  { src: en10, label: 'Engagement' },
  { src: sti01, label: 'Portrait' },
  { src: sti02, label: 'Portrait' },
];

const services = [
  {
    title: 'Wedding Photography',
    desc: 'Capturing every emotion, ritual, and celebration of your special day with candid, natural storytelling.',
    icon: 'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z',
  },
  {
    title: 'Cinematic Films',
    desc: 'Transforming real moments into timeless cinematic films with creative storytelling and artistic shots.',
    icon: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
  },
  {
    title: 'Pre-Wedding',
    desc: 'Telling your love story in a unique, artistic way — real emotions, chemistry, and unforgettable moments.',
    icon: 'M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z',
  },
  {
    title: 'Baby & Family',
    desc: 'Gentle, safe newborn shoots and joyful family portraits — love, laughter, and togetherness.',
    icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z',
  },
];

const stats = [
  { number: '35+', label: 'Years of Legacy' },
  { number: '10,000+', label: 'Happy Families' },
  { number: '3', label: 'Studio Branches' },
  { number: '50+', label: 'Team Members' },
];

export default function Home() {
  useScrollAnimation();
  const [lightboxIdx, setLightboxIdx] = useState(null);

  return (
    <main>
      {/* ═══ INTRO ═══ */}
      <section className="pt-10 pb-10 bg-charcoal">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="hero-subtitle text-gold-light text-sm md:text-base mb-4 tracking-[0.3em] uppercase">
            Established 1989
          </p>
          <h1 className="hero-title text-5xl md:text-7xl lg:text-8xl text-cream mb-4">
            Sabitha Studio
          </h1>
          <div className="gold-line mb-4" />
          <p className="text-cream/80 text-xl md:text-2xl max-w-2xl mx-auto mb-8">
            Where moments become timeless memories
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/wedding" className="btn-gold">View Our Work</Link>
            <a href="tel:+919703377033" className="btn-outline">Get in Touch</a>
          </div>

        </div>
      </section>

      {/* ═══ ABOUT ═══ */}
      <section className="py-14 md:py-20 bg-charcoal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 fade-up">
            <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">Our Story</p>
            <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-6">
              A Legacy of <span className="italic text-gold">Excellence</span>
            </h2>
            <div className="gold-line mb-8" />
            <p className="text-cream/65 max-w-3xl mx-auto text-base md:text-lg leading-[1.8] font-light">
              With a legacy that began in <strong className="text-gold font-medium">1989</strong>, we are proud to be a complete
              photography and videography service provider, trusted by generations of families. Our expertise spans
              photography, videography, cinematic videography, photo album designing, and professional video editing,
              delivering high-quality visuals that beautifully preserve life's most meaningful moments.
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-14 stagger">
            {stats.map((stat, i) => (
              <div key={i} className="fade-up text-center py-8 px-4 border border-gold/8 rounded hover:border-gold/25 transition-colors duration-500">
                <p className="font-playfair text-3xl md:text-4xl gold-text mb-2">{stat.number}</p>
                <p className="text-cream/50 text-[10px] tracking-[0.2em] uppercase font-montserrat">{stat.label}</p>
              </div>
            ))}
          </div>

          {/* Why Choose Us */}
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="fade-left">
              <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">Why Choose Us</p>
              <h3 className="font-playfair text-3xl md:text-4xl text-cream mb-6">
                Crafting Memories with <span className="italic text-gold">Passion</span>
              </h3>
              <p className="text-cream/60 leading-[1.8] mb-8 font-light text-sm md:text-base">
                We specialize in capturing celebrations with creativity, emotion, and precision. From pre-wedding shoots,
                weddings, and receptions to birthday events, saree ceremonies, seemantham, cradle ceremonies, and
                retirement functions — we cover every occasion with the same passion and attention to detail.
              </p>
              <ul className="space-y-4">
                {[
                  'Experienced in Indian wedding traditions',
                  'Professional cameras & high-end cinematic equipment',
                  'Creative & experienced photography team',
                  'Premium editing & timely delivery',
                  'Personalized approach for every client',
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-cream/65 text-sm">
                    <span className="w-1.5 h-1.5 rounded-full bg-gold shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="fade-right">
              <div className="relative">
                <div className="absolute -inset-3 border border-gold/10 rounded" />
                <img
                  src={prew01}
                  alt="Sabitha Studio photography"
                  className="w-full h-[520px] object-cover rounded relative z-10"
                />
                <div className="absolute -bottom-6 -right-6 w-24 h-24 border-r border-b border-gold/20 rounded-br z-0" />
                <div className="absolute -top-6 -left-6 w-24 h-24 border-l border-t border-gold/20 rounded-tl z-0" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* ═══ SERVICES ═══ */}
      <section
        className="parallax-section py-14 md:py-20"
        style={{ backgroundImage: `url(${wed05})` }}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-10 fade-up">
            <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">What We Offer</p>
            <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-6">
              Our <span className="italic text-gold">Services</span>
            </h2>
            <div className="gold-line" />
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 stagger">
            {services.map((service, i) => (
              <div
                key={i}
                className="fade-up p-8 bg-charcoal/70 backdrop-blur-sm border border-gold/8 rounded hover:border-gold/25 transition-all duration-500 group"
              >
                <div className="text-gold mb-6 flex justify-center">
                  <svg className="w-8 h-8 group-hover:scale-110 transition-transform duration-500" fill="none" stroke="currentColor" strokeWidth="1.2" viewBox="0 0 24 24">
                    <path d={service.icon} />
                  </svg>
                </div>
                <h3 className="font-playfair text-lg text-cream mb-3">{service.title}</h3>
                <p className="text-cream/50 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ GALLERY ═══ */}
      <section className="py-14 md:py-20 bg-charcoal">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 fade-up">
            <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">Our Portfolio</p>
            <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-6">
              Captured <span className="italic text-gold">Moments</span>
            </h2>
            <div className="gold-line mb-6" />
            <p className="text-cream/50 max-w-xl mx-auto text-sm font-light">
              A curated selection from our finest work — every frame tells a story of love, joy, and celebration.
            </p>
          </div>

          <div className="masonry-grid">
            {albumImages.map((img, i) => (
              <div
                key={i}
                className="album-card scale-up"
                onClick={() => setLightboxIdx(i)}
              >
                <img src={img.src} alt={img.label} loading="lazy" />
                <div className="overlay">
                  <span className="text-cream text-xs font-montserrat tracking-[0.12em] uppercase">{img.label}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-10 fade-up">
            <Link to="/wedding" className="btn-outline">
              Explore Full Gallery
            </Link>
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* ═══ EXPERIENCE QUOTE ═══ */}
      <section
        className="parallax-section py-14 md:py-20"
        style={{ backgroundImage: `url(${en05})` }}
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center fade-up">
          <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-4">The Experience</p>
          <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-6">
            More Than Just <span className="italic text-gold">Photography</span>
          </h2>
          <p className="text-cream/75 text-xl md:text-2xl leading-[1.8] font-light font-cormorant italic mb-8">
            "At every event, our focus is on creating natural, vibrant, and heartfelt visuals that you can
            cherish for a lifetime. Combining modern techniques with years of expertise, we are committed
            to delivering exceptional service, creativity, and lasting memories."
          </p>
          <div className="gold-line mb-6" />
          <p className="text-cream/40 text-xs font-montserrat tracking-[0.2em] uppercase">
            Trusted by generations of families across Telangana
          </p>
        </div>
      </section>

      {/* ═══ CONTACT ═══ */}
      <section className="py-14 md:py-20 bg-charcoal">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="fade-up">
            <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">Get in Touch</p>
            <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-6">
              Let's Create <span className="italic text-gold">Memories</span>
            </h2>
            <div className="gold-line mb-6" />
            <p className="text-cream/60 text-base md:text-lg mb-10 max-w-2xl mx-auto font-light">
              Whether it's a grand wedding or an intimate family portrait, we're here to capture your story beautifully.
            </p>
          </div>

          <div className="grid sm:grid-cols-3 gap-6 mb-10 stagger">
            {[
              { label: 'Main Branch', address: 'C-18, First Floor, Green Square Plaza, Opp. Public Gardens, Hanamkonda - 506001', phone: '+91-9703377033' },
              { label: 'Branch 2', address: 'Near WIN Motors, Srinivasa Colony, Erragattugutta, Hasanparthy, Hanamkonda - 506015', phone: '+91-9703355033' },
              { label: 'Branch 3', address: '10-30/A, Near Bus Stop, Kamalapur, Hanamkonda - 505102', phone: '+91-9440111443' },
            ].map((branch, i) => (
              <div key={i} className="fade-up p-8 border border-gold/8 rounded hover:border-gold/20 transition-colors duration-500">
                <h4 className="font-playfair text-lg text-gold mb-3">{branch.label}</h4>
                <p className="text-cream/45 text-xs leading-relaxed mb-4">{branch.address}</p>
                <a href={`tel:${branch.phone.replace(/-/g, '')}`} className="text-gold text-sm hover:text-gold-light transition-colors">
                  {branch.phone}
                </a>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center fade-up">
            <a href="tel:+919703377033" className="btn-gold">Call Now</a>
            <a href="https://wa.me/919703377033" target="_blank" rel="noopener noreferrer" className="btn-outline">WhatsApp Us</a>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxIdx !== null && (
        <Lightbox
          image={albumImages[lightboxIdx].src}
          onClose={() => setLightboxIdx(null)}
          onPrev={lightboxIdx > 0 ? () => setLightboxIdx(lightboxIdx - 1) : null}
          onNext={lightboxIdx < albumImages.length - 1 ? () => setLightboxIdx(lightboxIdx + 1) : null}
        />
      )}
    </main>
  );
}
